<template>
  <modal
    name="reset-modal"
    classes="reset-modal"
    height="auto"
  >
    <button
      class="close-btn"
      @click="$emit('close-modal', 'reset-modal')"
    >
      <icon
        name="cross"
        variant="a1a1a1"
      />
    </button>
    <div class="warning-container">
      <icon
        name="warning"
        variant="white"
      />
    </div>
    <p class="modal-title">
      Warning
    </p>
    <p>This action cannot be undone.</p>
    <p>Are you sure you wish to continue?</p>
    <button
      class="reset-btn"
      @click="$emit('reset-progress')"
    >
      Reset Progress
    </button>
    <button
      class="cancel-btn"
      @click="$emit('close-modal', 'reset-modal')"
    >
      Cancel
    </button>
  </modal>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  emits: ['close-modal', 'reset-progress'],
};
</script>

<style lang='scss'>
  .reset-modal {
    border-radius: rem-calc(10);
    background-color: #ffffff;
    text-align: center;
    width: rem-calc(620);
    max-width: 98%;

    @include breakpoint(small) {
      margin-left: 1%;
    }

    .close-btn {
      right: rem-calc(6);
      position: absolute;
      top: rem-calc(6);
      background: transparent;
      border: none;
      padding: 0;
      opacity: 0.4;

      @include breakpoint(small) {
        right: rem-calc(4);
      }

      img {
        height: rem-calc(20);
        width: rem-calc(20);

        @include breakpoint(small) {
          height: rem-calc(24);
          width: rem-calc(24);
        }
      }
    }

    > *:not(.close-btn) {
      margin: 0 auto;
    }

    .warning-container {
      background-color: #dc3416;
      height: rem-calc(60);
      width: rem-calc(60);
      border-radius: 50%;
      padding: rem-calc(12) rem-calc(14);
      box-sizing: border-box;
      margin-top: rem-calc(41);

      img {
        height: rem-calc(31);
      }
    }

    .modal-title {
      font-size: rem-calc(32);
      font-weight: $bold;
      color: #000000;
      margin: rem-calc(27) auto rem-calc(18);
    }

    p:not(.modal-title) {
      line-height: 1.5;
      margin: 0;
      font-weight: normal;
    }

    .reset-btn,
    .cancel-btn {
      display: block;
    }

    .reset-btn {
      border-radius: rem-calc(8);
      background-color: #dc3416;
      color: #ffffff;
      font-size: rem-calc(22);
      font-weight: $semi-bold;
      padding: rem-calc(15) rem-calc(20);
      margin-top: rem-calc(41);
    }

    .cancel-btn {
      margin: rem-calc(32) auto;
      background: transparent;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
